import { createFileRoute } from '@tanstack/react-router'
import IcpDetailPage from '@/components/business-value/IcpDetailPage'
import { logistics } from '@/data/business-value'

export const Route = createFileRoute('/_app/business-value/logistics')({
  component: LogisticsPage,
})

function LogisticsPage() {
  return <IcpDetailPage icp={logistics} />
}
